function formatDisplayUsername({
  name,
  nameInOffice
}) {
  return nameInOffice !== "" && nameInOffice !== name ? `${nameInOffice} (${name})` : name;
}

export { formatDisplayUsername };
//# sourceMappingURL=formatDisplayUsername.mjs.map
